import { APP_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const styles = {
  clearButton: {
    backgroundColor: "#27B6CB",
    color: "black",
    height: "50px",
    marginRight: "1px",
    "&:hover": {
      backgroundColor: "#759AC0",
    },
  } as const,
  arrowContainer: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50px",
  } as const,
  selectField: {
    width: "200px",
    fontFamily: FONT_FAMILY,
    color: TEXT_COLOR,
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: APP_COLOR,
    },
  } as const,
  sliderContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 2,
    marginLeft: 2,
    width: 200,
    flexDirection: "column",
  }as const
};
